import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
//import * as pConsts from '../consts/profiles-consts';
import CountrySelect from "../components/countryselect";
import {FormattedMessage} from "react-intl";
import * as pActs from "../actions/profiles-actions";

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
      searchTxt: ""
    };
    this.showLogin = this.showLogin.bind(this);

  }

  componentDidUpdate() {
    try {
      if (typeof window !== "undefined") {
        window.WireListButtons();
      }
    } catch (ex) { }
  }


  showLogin() {
    this.props.dispatch(wActs.showLogin());
  }

  toggleMenu(e) {
    e.preventDefault();
    
    if (this.state.mobileMenuOpen) {
      //document.documentElement.classList.remove("no-scroll");
      this.setState({mobileMenuOpen: false});
    } else {
      //document.documentElement.classList.add("no-scroll");
      this.setState({mobileMenuOpen: true});
    }
  }

  handleKeyPress(event) {
    if(event.key === 'Enter'){
      event.preventDefault();
      //this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
      this.props.dispatch(pActs.searchProfiles(this.state.searchTxt));
      this.handleSideMenuClick();
    }
  }

  handleChange(event) {
    this.setState({searchTxt: event.target.value})
  }

  handleSearchButton(event) {
    event.preventDefault();
    //this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
    this.props.dispatch(pActs.searchProfiles(this.state.searchTxt));
    this.handleSideMenuClick();
  }

  searchProfiles() {

  }

  domainLogo() {
    let ref = this.props.ServerParams.Referer;
    if (typeof ref === "undefined") {
      ref = "https://stage.redlight.nl:3000/";
    }
    let domain = ref.replace("https://").replace("http://").split("/")[0];
    domain = domain.split(":")[0];
    domain = domain === "localhost" || domain.startsWith('10.') ? "www.redlight.nl" : domain;
    let name = "";
    let prts = domain.split(".");
    name = prts[prts.length-2];
    return ( <img src={`/imgs/${name}.svg`} alt="" /> );
  }

  handleLogout(e) {
    e.preventDefault();
    //localStorage.removeItem('siteways-bearer');
    wActs.removeCookie("auth");
    window.location.reload();
  }

  handleSideMenuClick() {

  }

  handleMobileMenuClick() {
    window.mmenuOpen();
  }
  handleMobileMenuClose() {
    window.mmenuClose();
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  hasRole(role) {
    let hasRole = false;
    let user = this.props.WebPage.User;
    if(!wActs.isNullOrUndefined(user.Roles) && user.Roles.length) {
      user.Roles.map((v) => {
        if(v === role) {
          hasRole = true;
        }
      })
    }
    return hasRole;
  }


  selectedLocale() {
    let loc = this.props.WebPage
  }

  getTerm() {
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com" + this.props.WebPage.ServerParams.Query;
    }
    return wActs.getParameterByName("term", url, "");
  }

  render() {

    let showList = false;
    let showThumbs = false;
    let showXL = false;
    showList = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t == "List"}).length>0;
    showThumbs = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t == "Thumbs"}).length>0;
    showXL = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t == "XL"}).length>0;


    let hLink = wActs.getCultPath(this.props.WebPage,"/");
    //console.log(hLink);
    if(hLink.endsWith("/")) { hLink = hLink.substr(0,hLink.length-1); }
    //console.log(hLink);
    let term = this.getTerm();
    const colT = this.props.WebPage.Settings.ColorTheme.toLowerCase();
    return (
      <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <header>
              <Link to={hLink} title="" className={`header-link`}  style={{float: this.props.pageType === "profile" ? "" : "left"}}>
                <img src={this.props.WebPage.Settings.LogoUrl} alt={this.props.WebPage.Settings.SeoName} />
              </Link>

              <nav>
                <ul>
                  {this.props.WebPage.Menu.Header.map((v,i) => {
                    if(v.Page) {
                      return <li key={"mnuli-1-" + i}><Link key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                    } else {
                      if(v.Settings) {
                        return <li key={"mnuli-1-" + i}><a key={"mnu" + i} href={v.Settings.Url} title={v.Description} target="_blank">{v.Title}</a></li>;
                      }
                    }
                    return null;
                  })}
                </ul>
                <CountrySelect/>
              </nav>



              <button className="toggle-mbtn" onClick={(e) => { this.handleMobileMenuClick()}}>
                <span></span>
                <span></span>
                <span></span>
              </button>


              <div className="mobile-menu-wrapper" id="menu_open">
                <div className="mmenu-header">
                  <Link to={hLink} title="" className={`header-link`}  style={{float: this.props.pageType === "profile" ? "" : "left"}}>
                    <img src={this.props.WebPage.Settings.LogoUrl} alt={this.props.WebPage.Settings.SeoName} />
                  </Link>
                  <button className="close-mbtn" onClick={(e) => { this.handleMobileMenuClose()}}>
                    <span></span>
                    <span></span>
                  </button>
                </div>
                <ul className="main-nav">
                  <CountrySelect/>
                  {this.props.WebPage.Menu.Header.map((v,i) => {
                    if(v.Page) {
                      return <li key={"mnuli-1-" + i}><Link onClick={(e) => {this.handleMobileMenuClose()}} className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                    } else {
                      if(v.Settings) {
                        return <li key={"mnuli-1-" + i}><a onClick={(e) => {this.handleMobileMenuClose()}} className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                      }
                    }
                    return null;
                  })}
                  {this.props.WebPage.Menu.Footer.map((v,i) => {
                    if(v.Page) {
                      return <li key={"mnuli-1-" + i}><Link onClick={(e) => {this.handleMobileMenuClose()}} className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                    } else {
                      if(v.Settings) {
                        return <li key={"mnuli-1-" + i}><a onClick={(e) => {this.handleMobileMenuClose()}} className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                      }
                    }
                    return null;
                  })}

                </ul>

              </div>

            </header>
          </div>
        </div>
      </div>
      <div className="searchbar">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="searchbar-wrapper">
                <div className="search-form">
                  <form action="">
                    <input type="button" onClick={(e) => {this.handleSearchButton(e)}}/>
                    <input defaultValue={term} name="" onKeyPress={(evt) => { this.handleKeyPress(evt) }} onChange={(evt) => { this.handleChange(evt) }} type="text" placeholder={this.getTranslation("menu.search")}/>
                  </form>
                </div>
                {this.props.WebPage.PageType === "home" &&
                  <div className="toggle-view">
                    {showList &&
                      <a href="#none" className="list_view" data-img="list_view">
                        <img src={`/imgs/${colT}/list_view_active.png`} alt="List"/>
                        <img src={`/imgs/${colT}/list_view.png`} alt="List"/>
                      </a>
                    }
                    {showThumbs &&
                      <a href="#none" className="thumb_view active" data-img="thumb_view">
                        <img src={`/imgs/${colT}/thumb_view_active.png`} alt="Thumb"/>
                        <img src={`/imgs/${colT}/thumb_view.png`} alt="Thumb"/>
                      </a>
                    }
                    {showXL &&
                      <a href="#none" className="xl_view" data-img="xl_view">
                        <img src={`/imgs/${colT}/xl_view_active.png`} alt="XL"/>
                        <img src={`/imgs/${colT}/xl_view.png`} alt="XL"/>
                      </a>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      </React.Fragment>


    );
  }


}


const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams
  };
}

export default withRouter(connect(mapStateToProps)(Header));
